import PropTypes from 'prop-types'

/*
EXAMPLE:
{
  avatar: 'avatar.jpg',
  email: 'email',
  first_name: 'fname',
  id: 'ABC',
  last_name: 'lname',
  level: 23,
  name: 'Name Last',
  points: 23,
  username: 'username',
}
*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  email: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  level: PropTypes.number,
  name: PropTypes.string,
  points: PropTypes.number,
  username: PropTypes.string,
})
